// API endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  ME: '/auth/me',
  
  // Stats
  DASHBOARD_STATS: '/stats/dashboard',
  
  // Services
  SERVICES: '/services',
  UPCOMING_SERVICES: '/services/upcoming',
  RECENT_SERVICES: '/services/recent',
  FREQUENCY: '/services/frequency',
  
  // Songs
  SONGS: '/songs',
  SONGS_SEARCH: '/songs/search',
  
  // Users
  USERS: '/users',
  USERS_SEARCH: '/users/search',
  
  // Positions
  POSITIONS: '/positions',
  
  // Youtube
  YOUTUBE: '/youtube/search',
  YOUTUBE_TITLE: '/youtube/title',
};

export const ROLES = {
  ADMIN: 'admin',
  MUSICIAN: 'musician',
  VOCALIST: 'vocalist',
  TECH: 'tech',
};

export const POSITIONS = {
  VOCALS: 'vocals',
  GUITAR: 'guitar',
  BASS: 'bass',
  DRUMS: 'drums',
  KEYS: 'keys',
  SOUND: 'sound',
  PROJECTION: 'projection',
};
